export default __webpack_public_path__ + "static/media/Undercover_White.edc873fa.jpg";